import { gql } from "@apollo/client";

export const GET_PUBLIC_CHALLENGES = gql`
  query GetPublicChallenges {
    publicChallenges {
      id
      title
      description
      type
      status
      mode
      currentStreak
      bestStreak
      totalDays
      isPublic
      isStaked
      stakedAmount
      participantsCount
      startDate
      endDate
      createdAt
      updatedAt
      user {
        id
        name
      }
    }
  }
`;

export const GET_CHALLENGE = gql`
  query GetChallenge($id: ID!) {
    challenge(id: $id) {
      id
      title
      description
      type
      status
      mode
      currentStreak
      bestStreak
      totalDays
      isPublic
      isStaked
      stakedAmount
      participantsCount
      startDate
      endDate
      createdAt
      updatedAt
      user {
        id
        name
        email
      }
      updates {
        id
        type
        content
        dayNumber
        imageUrl
        images
        likesCount
        commentsCount
        createdAt
        user {
          id
          name
          email
        }
      }
    }
  }
`;

export const GET_CHALLENGE_FEED = gql`
  query GetChallengeFeed {
    challengeFeed {
      id
      type
      content
      dayNumber
      imageUrl
      images
      likesCount
      commentsCount
      createdAt
      comments {
        id
        content
        createdAt
        user {
          id
          name
          email
        }
      }
      user {
        id
        name
        email
      }
      challenge {
        id
        title
        type
        status
      }
    }
  }
`;

export const GET_ALL_CHALLENGE_UPDATES = gql`
  query GetAllChallengeUpdates($limit: Float, $offset: Float) {
    allChallengeUpdates(limit: $limit, offset: $offset) {
      id
      type
      content
      dayNumber
      imageUrl
      images
      likesCount
      commentsCount
      createdAt
      comments {
        id
        content
        createdAt
        user {
          id
          name
          email
        }
      }
      user {
        id
        name
        email
      }
      challenge {
        id
        title
        type
        status
      }
    }
  }
`;
